export const TOGGLE_PANEL_SHOW = 'editPanel/togglePanelShow';